import React from 'react';
import { cwcotTxt } from "@/setting";
import { trackButtonClick } from '@/utils/analytics';
import { markInternalNavigation } from '@/utils/attributionCapture';

const CwcotSales = ({label}) => {
  return (
    <div className="pdpGenericContainer mb30">
      <div className="container">
        <div className="">
          <h4 className="propertyInfoBoxHeadingText p0">CWCOT</h4>
          <p className="pdpTextBlack">{label} {" "}
            <a
              className='text-decoration-underline learnMoreLink '
              style={{fontSize:16}}
              href="https://www.hubzu.com/auctions?listingType=AUCN&category=secondchance"
              target="_blank"
              onClick={() => {
                markInternalNavigation();
                trackButtonClick({
                  eventName: "learn_more_cwcot_sales",
                  eventCategory: "NEW-PDP",
                  eventSource: "on learn more click",
                });
              }}
            >
              Learn more
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CwcotSales;